import getAppRoot from '../../../utils/getAppRoot';
import { BillingPlanUpdatedDtoModelType } from '../../../models';

export default ({ store }: BillingPlanUpdatedDtoModelType) => {
  const rootStore = getAppRoot(store);

  rootStore.billing.setNewPlanLoading(false);
  rootStore.customerNotification.getCNSettings();
};
